import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Circuit } from '../models/circuit';
import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class CircuitService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Circuit> {
    return new Promise((resolve, reject) => {
     return this.http.get(AppSettings.API_ENDPOINT + 'circuits/id/' + id).subscribe((response:any) => {
      if(response.type == 'circuit' && response.data){
        resolve(response.data);
        } else {
          reject(response);
        }

      }, error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            } else {
              reject(error_response);
            }
    });

   });

  }

}

